import { Content } from "@/components/ui/ContentArea";
import { ProyectoView } from "./ProyectoView";

export function ProyectoPage() {
	return (
		<Content className="p-5 w-full">
			<title>Proyecto</title>
			<ProyectoView />
		</Content>
	);
}
